module.exports = __webpack_public_path__ + "img/logo.e0b00029.png";